export default __webpack_public_path__ + "static/media/MB-Content-icon.e6ba0547.png";